import PropTypes from "prop-types";

const StarIcon = ({ width = 14, height = 14 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.00014 0.100098L9.53574 3.8099L13.8479 5.0753L11.1029 8.6333L11.2319 13.1249L7.00014 11.6141L2.76834 13.1249L2.89734 8.6333L0.152344 5.0753L4.46454 3.8099L7.00014 0.100098ZM5.80014 7.0001H4.60014C4.60013 7.62623 4.84482 8.22758 5.28199 8.67582C5.71915 9.12407 6.31419 9.38373 6.94012 9.39939C7.56606 9.41504 8.17333 9.18546 8.63237 8.75964C9.0914 8.33381 9.36585 7.74545 9.39714 7.1201L9.40014 7.0001H8.20014C8.20154 7.31149 8.08183 7.61123 7.86632 7.83599C7.6508 8.06075 7.35635 8.19294 7.04518 8.20462C6.73401 8.21631 6.43048 8.10657 6.19871 7.8986C5.96695 7.69063 5.8251 7.40072 5.80314 7.0901L5.80014 7.0001Z"
      fill="#FEBC2F"
    />
  </svg>
);

StarIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

export default StarIcon;
